
const TiersAdresseForm = function(element) {
    this.element = $(element);
    this.group = this.element.closest('.input-group');
    this.edit = this.group.find('[data-edit]');
    this.search = this.group.closest('.input-group').find('[data-search]');
    this.adresse = this.element.closest('form').find('[data-tiers-adresse]');

    // Sélection d'un tiers
    this.search.on('modal-show.modal', event => {
        const modal = event.modal,
            element = event.element;

        element.find('table').on('dbl-click-row.bs.table', (event, data) => {
            let value = this.element.val();

            if (this.element.prop('multiple')) {
                value.push(data.id);
            } else {
                value = data.id;
            }

            this.element.val(value).trigger('change');

            modal.hide();
        });
    });

    // Mise à jour d'un tiers
    this.element.on('change', (event) => {
        this.updateEditButton();
    });

    this.edit.on('modal-hide.modal', (event) => {
        this.updateEditButton();
    });
    this.updateEditButton();
};

$.extend(TiersAdresseForm.prototype, {
    updateEditButton: function() {
        const id = this.element.val();

        if (id) {
            // Mode édition
            this.edit.removeAttr('data-create');
            this.edit.attr('href', Routing.generate('tiers_edit', {
                tiers: id
            }));
            this.edit.find('i').removeClass('zmdi-plus').addClass('zmdi-edit');
        } else {
            // Mode création
            this.edit.attr('data-create', '');
            this.edit.attr('href', Routing.generate('tiers_create'))
            this.edit.find('i').addClass('zmdi-plus').removeClass('zmdi-edit');
        }

        this.loadAdresses();
    },

    loadAdresses: function () {
        if (!this.adresse.length) {
            return;
        }

        const id = this.element.val();

        if (id) {
            $.ajax({
                url: Routing.generate('tiers_adresse_index', {
                    tiers: id,
                    _format: 'json'
                }),
                success: response => {
                    let selected = this.adresse.val();

                    this.adresse.find('option[value!=""]').remove();
                    response.data.forEach((adresse) => {
                        let label = adresse.adresse ? adresse.adresse.split("\n") : [];
                        label.push((adresse.codePostal ? adresse.codePostal : '') + ' ' + (adresse.ville ? adresse.ville : ''));

                        this.adresse.append('<option value="' + adresse.id + '">' + label.join(' - ') + '</option>');
                    });

                    if (selected && this.adresse.find('[value="' + selected + '"]').length) {
                        this.adresse.val(selected);
                    } else {
                        let options = this.adresse.find('[value!=""]');
                        if (options.length == 1) {
                            options.prop('selected', true);
                        }
                    }
                    this.adresse.selectpicker('refresh');
                    this.adresse.trigger('change');
                }
            })
        }
    }
});

const tiersAdresseForm = () => {
    const selector = 'select[data-tiers-choice]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new TiersAdresseForm(this);
    });
};

export { tiersAdresseForm }


// WEBPACK FOOTER //
// ./js/form/tiersAdresse.js